import { RouterModule } from '@angular/router';
import { HomeModule } from './pages/home/home.module';
import { AuthModule } from './core/auth/auth.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { APIClient } from './core/api-client/contracts/api-client.service';
import { APIErrorHandler } from './core/api-client/contracts/api-error-handler.service';
import { NavMenuModule } from './core/nav-menu/nav-menu.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppSettingsModule } from './core/app-settings/app-settings.module';
import { AutoLogoutComponent } from './pages/auto-logout/auto-logout.component';
import { NgIdleModule } from '@ng-idle/core';
import { HspaAPIClient } from './core/api-client/hspa-api-client.service';
import { HspaAPIErrorHandler } from './core/api-client/hspa-api-error-handler.service';
import { IdnsModule } from './pages/idns/idns.module';
import { FacilitiesModule } from './pages/facilities/facilities.module';
import { ClinicalModule } from './pages/clinical/clinical.module';
import { NotAuthorizedFacilityComponent } from './pages/not-authorized-facility/not-authorized-facility.component';
import { DevicesModule } from './pages/devices/devices.module';
import { DeviceTypesModule } from './pages/device-types/device-types.module';
import { HspaAPIClientInterceptor } from './core/api-client/interceptor/hspa-api-client-interceptor';
import { PrefixSuffixModule } from './pages/prefix-suffix/prefix-suffix.module';
import { UsersModule } from './pages/users/users.module';

@NgModule({ declarations: [
        AppComponent,
        NotAuthorizedComponent,
        NotAuthorizedFacilityComponent,
        AutoLogoutComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        AuthModule.forRoot(),
        AppSettingsModule,
        NavMenuModule,
        HomeModule,
        IdnsModule,
        FacilitiesModule,
        DevicesModule,
        DeviceTypesModule,
        PrefixSuffixModule,
        ClinicalModule,
        UsersModule,
        NgIdleModule.forRoot(),
        RouterModule.forRoot([
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
            },
            {
                path: 'idns',
                loadChildren: () => import('./pages/idns/idns.module').then((m) => m.IdnsModule),
                data: { isAdminParent: true }
            },
            {
                path: 'facilities',
                loadChildren: () => import('./pages/facilities/facilities.module').then((m) => m.FacilitiesModule),
                data: { isAdminParent: true }
            },
            {
                path: 'devices',
                loadChildren: () => import('./pages/devices/devices.module').then((m) => m.DevicesModule),
                data: { isAdminParent: true }
            },
            {
                path: 'devicetypes',
                loadChildren: () => import('./pages/device-types/device-types.module').then((m) => m.DeviceTypesModule),
                data: { isAdminParent: true }
            },
            {
                path: 'prefixsuffix',
                loadChildren: () => import('./pages/prefix-suffix/prefix-suffix.module').then((m) => m.PrefixSuffixModule),
                data: { isAdminParent: true }
            },
            {
                path: 'users',
                loadChildren: () => import('./pages/users/users.module').then((m) => m.UsersModule),
            },
            {
                path: 'clinician',
                loadChildren: () => import('./pages/clinical/clinical.module').then((m) => m.ClinicalModule),
            },
            { path: 'not-authorized', component: NotAuthorizedComponent },
            { path: 'not-authorized-facility', component: NotAuthorizedFacilityComponent },
            { path: '**', component: NotAuthorizedComponent },
        ], { useHash: true }
        //{ relativeLinkResolution: 'corrected' },
        ),
        NgbModule], providers: [
        { provide: APIClient, useClass: HspaAPIClient },
        { provide: HTTP_INTERCEPTORS, useClass: HspaAPIClientInterceptor, multi: true },
        { provide: APIErrorHandler, useClass: HspaAPIErrorHandler },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
